import React, { useContext, useState } from "react";
import ChatContext from "../contexts/ChatContext";

const ChatPage = () => {
  const { activeChatUser, messages, setMessages } = useContext(ChatContext);
  const [text, setText] = useState("");

  const sendMessage = () => {
    if (!text.trim()) return;
    setMessages(prev => ({
      ...prev,
      [activeChatUser?.id || 0]: [...(prev[activeChatUser?.id] || []), { text, sender: "me" }]
    }));
    setText("");
  };

  return (
    <div>
      <h2>Chat with {activeChatUser?.name || "Select a user"}</h2>
      <div style={{ height: "300px", overflowY: "auto", border: "1px solid #ccc", padding: "10px" }}>
        {(messages[activeChatUser?.id] || []).map((msg, i) => (
          <div key={i} style={{ textAlign: msg.sender === "me" ? "right" : "left" }}>
            <span>{msg.text}</span>
          </div>
        ))}
      </div>
      <div className="input-group mt-2">
        <input type="text" className="form-control" value={text} onChange={e => setText(e.target.value)} />
        <button className="btn btn-primary" onClick={sendMessage}>Send</button>
      </div>
    </div>
  );
};

export default ChatPage;
